export default "__VITE_ASSET__gOu0R4Jl__"